import React from 'react';

export default function Datenschutz(){
  return (
    <div style={{padding:'60px 6%'}}>
      <h2 className="title">Datenschutzerklärung</h2>
      <p>Wir nehmen Datenschutz ernst. Diese Seite informiert über Erhebung, Verarbeitung und Nutzung personenbezogener Daten.</p>
      <p>Cookies, Kontaktformulare und technische Daten: Wir verwenden nur notwendige Cookies und verarbeiten Kontaktanfragen zur Bearbeitung.</p>
      <p>--- (Platzhalter - bitte durch Datenschutzerklärung prüfen lassen.)</p>
    </div>
  );
}
